export default __webpack_public_path__ + "f59ef136d618d24c9617379627d45b3b98ad0fe746d30a005d8e0c37291d80b4.svg";